export default __webpack_public_path__ + "static/media/uiuxpageimg.5221dd51.png";